import { useEffect } from "react";
import { SiteLinks, PaywallPlans } from "../../../../../global/paywall/paywallInterfaces";
import { getPaywallSettingsFromLocalStorage } from "../../../../../global/paywall/authOperations";

interface PremiumPaywallDesktopSigninFinishProps {

}

declare const window: Window & {
  PAYWALL_PLANS: PaywallPlans
  PAYWALL_SITE_LINKS: SiteLinks;
}


export const PremiumPaywallDesktopSigninFinish = (props:PremiumPaywallDesktopSigninFinishProps) => {

  const contactUrl = typeof window !== "undefined" && window.PAYWALL_SITE_LINKS ? window.PAYWALL_SITE_LINKS.contact : '';
  const termsUrl = typeof window !== "undefined" && window.PAYWALL_SITE_LINKS ? window.PAYWALL_SITE_LINKS.terms : '';
  const privacyUrl = typeof window !== "undefined" && window.PAYWALL_SITE_LINKS ? window.PAYWALL_SITE_LINKS.privacy : '';



  useEffect(() => {
    if (!user) {
      location.reload();
    }
    const timeout = setTimeout(() => {
      location.reload();
    }, 3000);
    return () => clearTimeout(timeout);
  }, []);


  const user = getPaywallSettingsFromLocalStorage();
  const displayName = user && user.displayName || 'משתמש';

  return (
    <div className="premium-paywall-desktop-signin-finish">
      <div className="title">{`שלום ${displayName}`}</div>
      <div className="subtitle">
        שמחים שחזרת, מיד תיפתח הכתבה
      </div>

      <div className="resend-code-text">
        העמוד לא התרענן?<button onClick={() => window.location.reload()}>לחצו כאן</button>
      </div>
    </div>
  )
}
